import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import ButtonComp from "./Button";
import { string } from "../constants/string";
import { useClaimTypeStore } from "../store/useClaimTypeStore";

type WarningPopupProps = {
  open: boolean;
  onClose: () => void;
  warningError?: string;
  warningMessage?:string
};

const WarningPopup: React.FC<WarningPopupProps> = ({
  open,
  onClose,
  warningError,
  warningMessage
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const claimType = useClaimTypeStore((state) => state.claimType);
  const isDeathClaim = claimType === "DEATH";

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            height: 400,
            borderRadius: 4,
            overflow: "hidden",
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "primary.main",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 3,
          height: 100,
        }}
      >
        <WarningRoundedIcon
          sx={{ color: "primary.contrastText", fontSize: 90 }}
        />
      </Box>

      <DialogContent
        sx={{
          textAlign: "center",
          py: isMobile ? 3 : 4,
          px: isMobile ? 2 : 4,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <Typography variant="h1" gutterBottom>
            {string.warningPopup.heading}
          </Typography>
          <Typography
            fontSize={26}
            fontWeight={500}
            sx={{ mb: 4 }}
            lineHeight="normal"
          >
            {warningError ||
              (isDeathClaim
                ? string.warningPopup.para
                : warningMessage)}
          </Typography>
          <ButtonComp
            variant="contained"
            height={40}
            width={200}
            onClick={onClose}
          >
            {string.warningPopup.ok}
          </ButtonComp>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WarningPopup;
